import React from "react";
import logo from '../assets/TIRUN_LOGO.png' ;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faPhone } from '@fortawesome/free-solid-svg-icons';
import {faFacebook, faSquareInstagram, faYoutube} from '@fortawesome/free-brands-svg-icons';
import { faLinkedin } from "@fortawesome/free-brands-svg-icons/faLinkedin";
import { Link } from "react-router-dom";



const Footer=()=> {
    return(
        <>
        <div className="Footer-container">

            <div className="footer-row-1">
           
             <div className="footer-logo-section" style={{width:'30%',marginTop:'0vh'}}>
                <img src={logo} alt="Tirun Logo" />
                <p style={{width:'80%',marginTop:'-2vh'}}> TIRUN Travel Marketing is the Exclusive India representative of the Royal Caribbean Group with cruise brands Royal Caribbean International, Celebrity Cruises, Silversea and Azamara Cruises.
Find and book your cruise online with TIRUN, and be part of our 30+ year legacy!.</p>
             </div>

             <div className="footer-page-link">
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                {/* <li><Link to="/whycruise">Why Cruise</Link></li> */}
                <li><Link to="/contact">Contact Us</Link></li>
                <li><Link to="/singapore">Singapore Cruise</Link></li>
        
              </ul>

             </div>

             <div className="footer-quick-link">
             <ul>
                <li><Link to="/alreadybooked">Already Booked?</Link></li>
                <li><Link to="/terms_and_conditions">Terms & Conditions</Link></li>
                <li><Link to="/cancellation_policy">Cancellation & Refund Policy</Link></li>
                {/* <li><Link to="/FAQs">Help & FAQs</Link></li> */}
                <li><Link to="/privacy_policy">Privacy Policy</Link></li>
        
              </ul>

             </div>
           
             <div className="Get-in-touch" >

              <h5>Get in touch with our Cruise Counsellor</h5>
              <div className="footer-contact">
                <FontAwesomeIcon icon={faPhone} style={{color: "#ffffff",marginLeft:'5px',width:'35px',height:'30px'}} />
                <a href="tel:1800115464" style={{textDecoration: 'none', color: 'inherit'}}><h2>1800 11 5464</h2></a>
              </div>

              <div className="footer-socials">
                <h5>Follow Us :</h5>
              <a href="https://www.facebook.com/TIRUNTravelMarketing/" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faFacebook} style={{color:'white',height:'35px',width:'35px'}}/></a>
              <a href="https://www.instagram.com/tiruntravels/" target="_blank" rel="noreferrer"> <FontAwesomeIcon icon={faSquareInstagram} style={{color:'white',height:'35px',width:'35px'}}/></a>
              <a href="https://in.linkedin.com/company/tirun-travel-marketing" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faLinkedin} style={{color:'white',height:'35px',width:'35px'}}/></a>
              <a href="https://www.youtube.com/c/TIRUNTravelMarketingJustCruise" target="_blank" rel="noreferrer" ><FontAwesomeIcon icon={faYoutube} style={{color:'white',height:'35px',width:'35px'}}/></a>

              </div>



             </div>

            </div>

            <div className="footer-row-2">
            <p>Copyright © 2025 TIRUN. All Rights Reserved.</p>
            </div>
        </div>
        
        </>
    );
    
}


export default Footer;